<template>
  <form
    :action="formPostUrl"
    method="post"
    @submit="handleFormSubmit"
  >
    <input
      :value="formVals.name"
      name="LastName"
      type="hidden"
    >
    <input
      :value="formVals.customerId"
      name="PIN"
      type="hidden"
    >
    <input
      value=""
      name="ClientName"
      type="hidden"
    >
    <input
      value=""
      name="Year"
      type="hidden"
    >
    <div>
      <ul
        v-if="validationMsgs.length > 0"
        class="customer-form__validation-msg"
      >
        <li
          v-for="(validationMsg, validationMsgI) in validationMsgs"
          :key="validationMsgI"
        >
          {{ validationMsg }}
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label
            for="simpleLName"
            class="sr-only"
          >Last Name</label>

          <input
            id="simpleLName"
            v-model="formVals.name"
            :placeholder="contentfulText('customer-lookup-form-2023-v01-name-input-placeholder').Content"
            type="text"
            class="form-control"
          >
        </div>
      </div>
      <div class="col-xs-12 col-sm-6">
        <div class="form-group">
          <label
            for="simpleCustomerID"
            class="sr-only"
          >Customer ID</label>

          <input
            id="simpleCustomerID"
            v-model="formVals.customerId"
            :placeholder="contentfulText('customer-lookup-form-2023-v01-customer-id-input-placeholder').Content"
            type="text"
            class="form-control"
          >
        </div>
      </div>
    </div>
    <div class="row customer-form__second-row">
      <div class="col-xs-12 col-sm-6 col-sm-offset-3 col-md-6 col-md-offset-0 customer-form__btn-column">
        <button
          type="submit"
          class="btn customer-form__cta-btn"
        >
          {{ contentfulText('customer-lookup-form-2023-v01-submit-button-label').Content }}
        </button>
      </div>
      <div class="col-xs-12 col-md-6 text-center">
        <a
          :href="customerLookupUrl"
          class="customer-form__link"
          style="color: #000000"
        >
          {{ contentfulText('customer-lookup-form-2023-v01-customer-lookup-cta-label').Content }}
        </a>
      </div>
    </div>
  </form>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'CustomerFormSimple',
  data () {
    return {
      validationMsgs: [],
      formVals: {
        name: null,
        customerId: null
      }
    }
  },
  computed: {
    content () {
      return this.$store.state.searchFormContent
    },
    customerLookupUrl () {
      return this.$store.state.urls.customerLookup
    },
    formPostUrl () {
      return this.$store.state.urls.searchFormPost
    }
  },
  watch: {
    validationMsgs (v, ov) {
      if (v.length > 0) {
        this.$emit('validation-failed')
      } else {
        this.$emit('validation-successful')
      }
    }
  },
  methods: {
    handleFormSubmit (ev) {
      this.validationMsgs = []

      if (this.formVals.name === null || this.formVals.name.length === 0) {
        this.validationMsgs.push(this.contentfulText('customer-lookup-form-2023-v01-name-validation-message').Content)
      }

      if (this.formVals.customerId === null || this.formVals.customerId.length === 0) {
        this.validationMsgs.push(this.contentfulText('customer-lookup-form-2023-v01-customer-id-validation-message').Content)
      }

      if (this.validationMsgs.length > 0) {
        ev.preventDefault()
      } else {
        GoogleAnalytics.trackEvent('Search', 'Searched', 'Last Name and Customer ID')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-control {
  border-radius: 4px;
  font-family: $font-circular-std;
  font-weight: bold;
  height: 34px;
  padding: 0.25rem 0.75rem 0.18rem 0.75rem;
  color: #555;

  &::placeholder {
    text-transform: uppercase;
    color: #000;
  }
}

.customer-form {
  &__cta-btn {
    background-color: #d02a2f;
    border-radius: 16px;
    color: #fff;
    font-family: $font-circular-std;
    font-weight: bold;
    padding: 0.6rem 1.6rem;
    text-transform: uppercase;
    width: 100%;
  }

  &__btn-column {
    margin-bottom: 20px;

    @media screen and (min-width: $screen-md-min) {
      margin-bottom: 0;
    }
  }

  &__second-row {
    @media screen and (min-width: $screen-md-min) {
      display: flex;
      align-items: center;
    }
  }

  &__link {
    color: #fff;
    text-decoration: underline;
  }

  &__validation-msg {
    color: #fff;
    padding: 0.4rem 0;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/index/components/CustomerForms/CustomerFormSimple.vue